module.exports = __webpack_public_path__ + "static/media/inx_group_image.488b4075.png";